import BaseApi from "../BaseApi";

const baseApi = new BaseApi();

export default class SpellCheck {
  Entity = "spell_check";

  check = async (data = null) => {
    if (!data) {
      throw new Error("Data is null...!!!");
    }

    const action = "post";
    const processedData = {
        ...data,
	    similarity: true,
    };
    
    return baseApi.fullFetch(this.Entity, action, {data: processedData});
  }
}